import React, { Component } from 'react'
import { number, node, bool, string } from 'prop-types'
import { createComponent } from '@ycos/fela'

class ContentCarouselItem extends Component {
  shouldComponentUpdate(nextProps) {
    return this.props.visible !== nextProps.visible || this.props.width !== nextProps.width || this.props.translate !== nextProps.translate
  }

  render() {
    const { offset, transitionType, translate, visible, width, children } = this.props
    return (
      <Item
        data-automation={`content-carousel-item${visible ? '-visible' : ''}`}
        offset={offset}
        transitionType={transitionType}
        translate={translate}
        visible={visible}
        width={width}
      >
        {children}
      </Item>
    )
  }
}

ContentCarouselItem.propTypes = {
  visible: bool,
  offset: number,
  transitionType: string,
  width: number,
  translate: number,
  children: node.isRequired
}

ContentCarouselItem.defaultProps = {
  visible: false,
  offset: 0,
  transitionType: 'swipe',
  width: 0,
  translate: 0
}

const Item = createComponent('Item', ({ offset, transitionType, visible, translate, width, theme }) => ({
  position: 'relative',
  top: 0,
  left: `${offset}%`,
  width: `${width}%`,
  maxWidth: `${width}%`,
  minWidth: `${width}%`,
  boxSizing: 'border-box',
  pointerEvents: visible ? 'auto' : 'none',
  zIndex: visible ? 2 : 1,
  opacity: transitionType === 'swipe' || visible ? 1 : 0,
  transform: transitionType === 'swipe' ? `translateX(${translate}%)` : null,
  transitionProperty: 'all',
  transitionDuration: theme.custom.animations.slow,
  '& *': {
    pointerEvents: !visible ? 'none !important' : undefined
  }
}))
export default ContentCarouselItem
